import { useGetApiV1DocumentCourseRegistrationAttachmentDownload } from '@/shared/api/generated/hooks/documentCourseRegistrationController/useGetApiV1DocumentCourseRegistrationAttachmentDownload';

/**
 * Hook para obter a URL assinada de um documento de matrícula.
 *
 * A query só é disparada quando `attachmentId` é não-nulo, evitando
 * chamadas desnecessárias. `staleTime: 0` garante que a URL assinada
 * (que expira) seja sempre refetched ao reabrir o modal.
 *
 * @param attachmentId - ID do documento; `null` mantém a query desativada
 * @returns Dados da query: `data` (URL assinada), `isLoading`, `isError`
 *
 * @example
 * ```tsx
 * const { data: url, isLoading } = useEnrollmentDocumentDownload(doc.id);
 * ```
 */
export function useEnrollmentDocumentDownload(attachmentId: number | null) {
  return useGetApiV1DocumentCourseRegistrationAttachmentDownload(
    attachmentId !== null ? { attachmentId } : undefined,
    {
      query: {
        enabled: attachmentId !== null,
        staleTime: 0,
        gcTime: 0,
      },
    },
  );
}
